import { ReactElement } from 'react';

import { IconsPropsI } from './interfaces';

const CircleIcon = ({ width = 32, height = 32, fill = '#7F90AF' }: IconsPropsI): ReactElement => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="4" y="4" width="24" height="24" rx="12" fill="white" />
      <path
        d="M16 4C9.376 4 4 9.376 4 16C4 22.624 9.376 28 16 28C22.624 28 28 22.624 28 16C28 9.376 22.624 4 16 4ZM16 25.6C10.696 25.6 6.4 21.304 6.4 16C6.4 10.696 10.696 6.4 16 6.4C21.304 6.4 25.6 10.696 25.6 16C25.6 21.304 21.304 25.6 16 25.6Z"
        fill={fill}
      />
    </svg>
  );
};

export default CircleIcon;
